import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';
import ModalWindow from "../../../shared/ModalWindow";
import SupportModal from "../../../shared/SupportModal";
import ConfirmDocs from "../../../profile/ConfirmDocs";

const ProfilePassword = ({user,onOpenModal, closeModal, isModalOpen, changePassword, changeDisplay, changeModeration}) => {
  const { t } = useTranslation();
  const handleLogout = event => {
    event.preventDefault()
    event.stopPropagation()
    localStorage.removeItem('authData')
    window.location.href = '/login';
  };
    return (
        <div className={styles['profile__password']}>
            <div className={styles['profile__password-title']}>{t('profileTwo.settings.title')}</div>
            <hr className={styles['profile__password-hr']}></hr>
            <div className={styles['profile__password-subtitle']} onClick={changePassword}>{t('profileTwo.settings.changePassword')}</div>
            <button className={styles['profile__password-subtitle']} onClick={() => onOpenModal()}>{t('profileTwo.settings.uploadDocuments')}</button>
            {isModalOpen  && (
                <ModalWindow
                    contentFull
                    bgTransparent={false}
                    onClose={closeModal}
                    footerSlot={<SupportModal />}
                >
                    <ConfirmDocs
                        userId={user?.id}
                        updateData={() => {

                          changeModeration(true)
                            changeDisplay(false)
                        }}
                        onClose={closeModal}
                        isDisplayModal={isModalOpen}
                    />
                </ModalWindow>
            )}
            <button className={styles['profile__password-subtitle']} onClick={handleLogout} >{t('profileTwo.settings.logout')}</button>
        </div>
    );
};

export default ProfilePassword;
